import { DeleteOutlined } from '@ant-design/icons';
import { DivToast } from '@components/common/WapperNotification';
import { ThunkDispatch } from '@reduxjs/toolkit';
import {
  changeQActionOrder,
  getDetailOfOrder,
  removeNotification,
  updateOrderSelected
} from '@slice/orderManager.slice';
import { Tooltip } from 'antd';
import { RootState } from 'app/store';
import { useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

export default function ListNotification() {
  const { t } = useTranslation();
  const listNotification = useSelector((state: RootState) => state.orderManager.listNotification);
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const history = useNavigate();

  // cần xử lý như dạng này nếu đơn này chưa có trong list đơn bên menu quản lý đơn //

  const handleDetail = (maDonHang: string, orderTypeId?: number) => {
    console.log('maDonHang', maDonHang);
    if (window.location.pathname !== '/quan-ly-don-hang') {
      handleMenu(maDonHang);
    } else {
      dispatch(getDetailOfOrder({ maDonHang: maDonHang, typeOrder: +orderTypeId, forceOpen: true }));
      const notifyC = { maDonHang: maDonHang, clearAll: false }; // khi thao tác thì k đóng để test thêm cho dễ, khi nào đưa ra dùng thì đóng
      dispatch(removeNotification(notifyC)); // gọi lên lấy data mới luôn !!
      return;
    }
  };

  const handleMenu = (maDonHang: string, orderTypeId?: number) => {
    // toast.remove(maDonHang);
    history('/quan-ly-don-hang' + `?maDonHang=${maDonHang}`);
  };

  const handleQActions = (maDonHang: string, orderTypeId?: number) => {
    console.log('maDonHang', maDonHang);
    dispatch(updateOrderSelected(maDonHang));
    dispatch(changeQActionOrder(true));
  };

  const handleRemoveAllNotify = () => {
    console.log('Remove AllNotify');
    const notifyC = { maDonHang: undefined, clearAll: true };
    dispatch(removeNotification(notifyC));
  };

  const handleRemoveNotify = (maDonHang: string) => {
    console.log('Remove Notify');
    const notifyC = { maDonHang: maDonHang, clearAll: false };
    dispatch(removeNotification(notifyC));
  };

  // tạo style custom màu theo thêm luôn!!
  const renderListNotification = useMemo(() => {
    return listNotification.map((notify, index) => (
      <div className="flex py-2 hover:text-gray-300 space-x-2 w-full" key={notify.maDonHang}>
        <div className="text-lg font-semibold">{index + 1}</div>
        <DivToast
          notification={notify}
          handleDetail={handleDetail}
          handleMenu={handleMenu}
          handleQActions={handleQActions}
        />
        <div onClick={() => handleRemoveNotify(notify.maDonHang)} className="cursor-pointer hover:!text-red-500">
          X
        </div>
      </div>
    ));
  }, [listNotification]);

  return (
    <div className="ffs-text flex flex-col space-y-2 divide-y divide-white align-middle items-center p-3 max-h-[60vh] overflow-y-auto w-full">
      <div className="w-full flex justify-between">
        {listNotification.length != 0 ? (
          <>
            {/* {t('Notification.Title')} */}
            <div className="font-semibold !text-sm ">{'Danh sách'}</div>{' '}
            <Tooltip placement="topLeft" title={t('Notification.CloseAll')}>
              <div className="cursor-pointer" onClick={() => handleRemoveAllNotify()}>
                <DeleteOutlined
                  className="hover:text-orange-800"
                  rev={''}
                  style={{ fontSize: '16px', color: 'red', transform: 'translateY(0px)' }}
                />
              </div>
            </Tooltip>
          </>
        ) : (
          <>
            <div className="font-semibold !text-sm ">{t('Notification.NoNotify')}</div>
          </>
        )}
      </div>
      {renderListNotification}
    </div>
  );
}
